import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SvgIcon',
  props: {
    iconName: null
  },
  setup(__props: any) {

const props = __props as {
	iconName: string;
}



const classString = computed(() => `svg-icon icon-${props.iconName}`);
const hrefString = computed(() => `#icon-${props.iconName}`);

return { __sfc: true,props, classString, hrefString }
}

})